/**
 * Response dates normally arrive as Firestore Timestamps, but after the
 * service document has been cloned or serialised they are plain
 * `{ seconds, nanoseconds }` objects. Accept every shape so one stale value
 * can't blank the whole dashboard.
 */
export function toJSDate(value) {
  if (!value) return new Date(NaN);
  if (typeof value.toDate === "function") return value.toDate();
  if (value instanceof Date) return value;
  const seconds = value.seconds ?? value._seconds;
  if (typeof seconds === "number") {
    const nanos = value.nanoseconds ?? value._nanoseconds ?? 0;
    return new Date(seconds * 1000 + Math.floor(nanos / 1e6));
  }
  return new Date(value);
}
